<template>
    <div class="customer-connect">
        <v-page-header
            title="客户沟通"
            level="section"
        />

        <div class="customer-connect__main">
            <v-tip
                ref="qrcode"
                placement="top"
                kind="large"
                clazz="qrcode-poper-wrapper"
            >
                <template slot-scope="props">
                    <QrcodePoper
                        v-if="props.data"
                        :img="props.data.qrUrl"
                    />
                </template>
            </v-tip>
            <div class="customer-connect__left">
                <style-tab
                    v-model="selectComponent"
                    :options="[{value: 'pc', text: '电脑端'}, {value: 'mobile', text: '移动端'}]"
                />
                <!-- pc -->
                <div
                    v-if="selectComponent === 'pc'"
                    class="webim-window-demo"
                >
                    <div class="title-bar">
                        在线客服
                    </div>
                    <div class="mian-body">
                        <v-icon
                            v-if="initData.isUseWebNotice && channelType !== 1"
                            name="notice_bar"
                            class="notice-bar"
                        />
                        <div class="message-list">
                            <v-icon
                                name="message_bubble"
                                class="chat-message"
                            />
                        </div>
                        <div v-if="hasMigrated" class="interactive-nav-bar">
                            <!-- 这里用v-show，如果用v-if的话，重新显示时需要处理选中项数据 -->
                            <card
                                ref="navCard"
                                v-show="interactiveNavData.enableSwitch"
                                v-model="interactiveNavData"
                                :currNavMenuIndex.sync="currNavMenuIndex"
                                @addOne="$refs.interactiveNavSetting.addOne()"
                                @deleteOne="(index)=>$refs.interactiveNavSetting.deleteOne(index)"
                            />
                        </div>
                    </div>
                    <div class="bottom-box">
                        <div class="tools-bar">
                            <template v-for="(item, index) in toolBtnsForPC" >
                                <v-icon :key="index" :remote="item.remote" :name="item.icon" />
                            </template>
                        </div>
                        <div class="send-msg" />
                    </div>
                </div>
                <!-- mobile -->
                <div
                    v-if="selectComponent === 'mobile'"
                    class="mobile-show-block"
                >
                    <v-icon
                        name="new_mobile_customer_connect"
                        class="mobile-show-block__bg"
                    />
                    <div class="mobile-show-block__body">
                        <v-icon
                            v-if="initData.isUseWebNotice && channelType !== 1"
                            name="notice_bar_mobile"
                            class="notice-bar"
                        />
                        <div class="message-list">
                            <v-icon
                                name="message_bubble_mobile"
                                class="chat-message"
                            />
                        </div>
                    </div>
                    <div v-if="hasMigrated" class="interactive-nav-bar">
                        <card
                            ref="navCard"
                            v-show="interactiveNavData.enableSwitch"
                            v-model="interactiveNavData"
                            :currNavMenuIndex.sync="currNavMenuIndex"
                            @addOne="$refs.interactiveNavSetting.addOne()"
                            @deleteOne="(index)=>$refs.interactiveNavSetting.deleteOne(index)"
                        />
                    </div>
                    <div class="tools-box">
                        <div class="tools-top">
                            <v-icon
                                v-if="initData.isAllowSendShortVoice && channelType !== 1"
                                remote
                                name="basic_voice_line"
                            />
                            <div class="input-box">
                                <span>请点击输入</span>
                            </div>
                        </div>
                        <div class="tools-bottom">
                            <div class="tool-btn-item" v-for="(item, index) in toolBtnsForMobile" :key="index">
                                <v-icon :remote="item.remote" :name="item.icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="customer-connect__right">
                <div v-if="!!noticPrivilege && (channelType !== 1)">
                    <v-page-header
                        title="公告"
                        level="content"
                    >
                        <template slot="caption">
                            展示在客户网页会话顶部
                            &nbsp;
                            <a
                                href="/tp/IMAccessSet/webNotice"
                                target="_blank"
                            >管理公告</a>
                        </template>
                        <template slot="extra">
                            <v-switch
                                v-model="useNoticeBoolean"
                                :label="useNoticeBoolean?'已启用':'未启用'"
                            />
                        </template>
                    </v-page-header>
                </div>

                <!-- 输入框上方气泡 -->
                <interactive-nav-setting
                    v-if="hasMigrated"
                    ref="interactiveNavSetting"
                    v-model="interactiveNavData"
                    :channelType="channelType"
                    :currNavMenuIndex.sync="currNavMenuIndex"
                    :hasAdaptThemeColorPrivilege="hasAdaptThemeColorPrivilege"
                    @activeErrorMenu="$refs.navCard.scrollToElementIfNotInView()"
                />
                <div>
                    <v-page-header
                        title="客户互动功能"
                        level="content"
                    >
                        <template slot="caption">
                            展示在客户会话的工具栏中
                        </template>
                    </v-page-header>
                    <div class="section-item-line">
                        <label class="section-item-label">
                            选择功能
                        </label>
                        <div>
                            <div class="tools-btn-container">
                                <div v-if="channelType !== 1" class="checkbox-line">
                                    <v-tip
                                        ref="sendVoiceTip"
                                        kind="large"
                                        placement="right"
                                    >
                                        <send-voice-tip />
                                    </v-tip>
                                    <v-checkbox
                                        v-model="sendVoiceBoolean"
                                        label="发送短语音"
                                    />
                                    <v-icon
                                        v-tip:sendVoiceTip.hover
                                        name="input_question"
                                        class="input-question"
                                    />
                                </div>
                                <div class="checkbox-line">
                                    <v-tip
                                        ref="imageTip"
                                        kind="large"
                                        placement="right"
                                    >
                                        <file-image-tip type="image" />
                                    </v-tip>
                                    <v-checkbox
                                        v-model="imageBoolean"
                                        label="发送图片"
                                    />
                                </div>

                                <div class="checkbox-line">
                                    <v-tip
                                        ref="fileTip"
                                        kind="large"
                                        placement="right"
                                    >
                                        <file-image-tip type="file" />
                                    </v-tip>
                                    <v-checkbox
                                        v-model="fileBoolean"
                                        :label="channelType === 1 ? '发送视频' : '发送文件'"
                                    />
                                </div>
                                <div class="checkbox-line">
                                    <v-checkbox
                                        v-model="exitQueueBoolean"
                                        label="退出排队"
                                    />
                                </div>
                                <div
                                    v-if="channelType !== 1"
                                    class="checkbox-line"
                                >
                                    <v-checkbox
                                        v-model="recallBoolean"
                                        label="客户撤回消息"
                                    />
                                </div>
                                <div
                                    v-if="isDefaultTpl && enableCapture === 1"
                                    class="checkbox-line"
                                >
                                    <v-tip
                                        ref="captureTip"
                                        kind="large"
                                        placement="left"
                                    >
                                        <div class="capture-tip">
                                            开启后，客户可在电脑端网页展示“截图”入口，提示截图方式
                                        </div>
                                    </v-tip>
                                    <v-checkbox
                                        v-model="captureBoolean"
                                        label="截图"
                                    />
                                    <v-icon
                                        v-tip:captureTip.hover
                                        name="input_question"
                                        class="input-question"
                                    />
                                </div>

                                <div class="checkbox-line">
                                    <v-tip
                                        ref="satisfactionTip"
                                        kind="large"
                                        placement="left"
                                        clazz="manual-close-tip__wrapper"
                                    >
                                        <satisfaction-tip />
                                    </v-tip>
                                    <v-checkbox
                                        v-model="surveyBoolean"
                                        label="服务评价"
                                    />
                                    <!-- {{!!initData.isSurvey}} -->
                                    <v-icon
                                        v-tip:satisfactionTip.hover
                                        name="input_question"
                                        class="input-question"
                                    />
                                </div>
                                <div class="checkbox-line">
                                    <v-tip
                                        ref="manualCloseTip"
                                        kind="large"
                                        placement="left"
                                        clazz="manual-close-tip__wrapper"
                                    >
                                        <manual-close-tip />
                                    </v-tip>
                                    <v-checkbox
                                        v-model="manualCloseBoolean"
                                        label="结束会话"
                                    />
                                    <v-icon
                                        v-tip:manualCloseTip.hover
                                        name="input_question"
                                        class="input-question"
                                    />
                                </div>
                                <div v-if="channelType !== 1" class="checkbox-line">
                                    <v-tip
                                        ref="authorizeTip"
                                        kind="large"
                                        placement="right"
                                    >
                                        <div class="authorize-tip">
                                            客户发送照片或文件时将触发内容授权提醒进行确认，且每刷新页面都将再次提醒授权
                                            <div class="authorize-tip-img" />
                                        </div>
                                    </v-tip>
                                    <v-checkbox
                                        v-model="contentAuthorizeBoolean"
                                        label="内容授权提醒"
                                    />
                                    <v-icon
                                        v-tip:authorizeTip.hover
                                        name="input_question"
                                        class="input-question"
                                    />
                                    <span
                                        @click="onContentAuthorizeTipEdit"
                                        class="authorize-edit"
                                    >编辑</span>
                                    <v-dialog
                                        v-model="showContentAuthorizeTipEdit"
                                        class="authorize-tip-edit"
                                    >
                                        <v-form
                                            ref="authorizeTipEditForm"
                                            @submit="authorizeTipSubmit"
                                            :model="authorizeTip"
                                        >
                                            <v-form-item
                                                :rules="authorizeTipEditFormRules.title"
                                                name="title"
                                                required="内容不能为空"
                                                error-placement="top-right"
                                            >
                                                <v-input
                                                    v-model="authorizeTip.title"
                                                    :limit="28"
                                                    kind="simple"
                                                    placeholder="授权提醒标题"
                                                    style="width:400px;"
                                                />
                                            </v-form-item>
                                            <v-form-item
                                                :rules="authorizeTipEditFormRules.explain"
                                                name="explain"
                                                error-placement="top-right"
                                            >
                                                <v-input
                                                    v-model="authorizeTip.explain"
                                                    :limit="38"
                                                    kind="simple"
                                                    placeholder="补充说明(选填)"
                                                    style="width:400px;"
                                                />
                                            </v-form-item>
                                            <v-form-item class="options">
                                                <v-button
                                                    :disabled="authorizeFormError"
                                                    type="submit"
                                                    kind="primary"
                                                    style="margin-right: 10px;"
                                                >
                                                    确定
                                                </v-button>
                                                <v-button
                                                    @click="hiddenContentAuthorizeTipEdit"
                                                    kind="default"
                                                >
                                                    取消
                                                </v-button>
                                            </v-form-item>
                                        </v-form>
                                    </v-dialog>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ManualCloseTip from '../../manual-close-tip/index';
import SatisfactionTip from '../../satisfaction-tip/index';
import SendVoiceTip from '../../send-voice-tip/index';
import FileImageTip from '../../file_image_tip/index';
import InteractiveNavSetting from './interactive-nav-setting';
import Card from './card';
import StyleTab from '../../style-tab';

import { authorizeTipDefault, CHATWINDOWSYSTEMEVENTTIPKEY } from '../config';
import { DEFAULT_NAV_SETTIGN } from './interactive-nav-setting/constants';

export default {
    components: {
        ManualCloseTip,
        SendVoiceTip,
        FileImageTip,
        SatisfactionTip,
        InteractiveNavSetting,
        Card,
        StyleTab,
    },
    props: {
        isDefaultTpl: {
            type: Boolean,
            default: false,
        },
        enableCapture: {
            type: Number,
            default: 0, // 1:展示截图配置项，0：不展示截图配置项，并且截图选项只在默认模板里面出现（isDefaultTpl字段标识）
        },
        connectData: {
            type: Object,
            default: () => {},
        },
        channelType: {
            type: Number,
            default: 0,
        },
        hasMigrated: {
            type: Boolean,
            default: false,
        },
        hasAdaptThemeColorPrivilege: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const { data = {} } = window.pageData || {};

        return {
            initData: {
            },
            showSystemTip: !localStorage.getItem(CHATWINDOWSYSTEMEVENTTIPKEY),
            noticPrivilege: data.noticPrivilege,
            showContentAuthorizeTipEdit: false,
            authorizeTip: { ...authorizeTipDefault },
            authorizeTipEditFormRules: {
                title: [{ maxLength: 28, message: '不能超过28个字符', trigger: 'input' }],
                explain: [{ maxLength: 38, message: '不能超过38个字符', trigger: 'input' }],
            },
            authorizeFormError: false,
            pageData: Object.freeze(window.pageData),
            selectComponent: 'pc',
            currNavMenuIndex: 0, // 当前选中菜单的索引
        };
    },
    computed: {

        manualCloseBoolean: {
            set(val) {
                this.initData.isManualClose = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isManualClose;
            },
        },
        surveyBoolean: {
            set(val) {
                this.initData.isSurvey = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isSurvey;
            },
        },
        sendVoiceBoolean: {
            set(val) {
                this.initData.isAllowSendShortVoice = +val ? 1 : 0;
            },
            get() {
                return !!+this.initData.isAllowSendShortVoice;
            },
        },
        useNoticeBoolean: {
            set(val) {
                this.initData.isUseWebNotice = +val ? 1 : 0;
            },
            get() {
                return !!+this.initData.isUseWebNotice;
            },
        },
        fileBoolean: {
            set(val) {
                this.initData.isAllowSendFile = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isAllowSendFile;
            },
        },
        exitQueueBoolean: {
            set(val) {
                this.initData.isAllowExitQueue = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isAllowExitQueue;
            },
        },
        recallBoolean: {
            set(val) {
                this.initData.isAllowRecall = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isAllowRecall;
            },
        },
        imageBoolean: {
            set(val) {
                this.initData.isAllowSendImage = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isAllowSendImage;
            },
        },
        captureBoolean: {
            set(val) {
                this.initData.isAllowCapture = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isAllowCapture;
            },
        },
        contentAuthorizeBoolean: {
            set(val) {
                this.initData.isContentAuthorize = val ? 1 : 0;
            },
            get() {
                return !!this.initData.isContentAuthorize;
            },
        },
        isShowGuidanceBlock() {
            const { initData } = this;
            return initData.guidanceWechat && initData.guidanceData && initData.guidanceData.key;
        },

        // 互动导航数据
        interactiveNavData: {
            set(val) {
                this.$set(this.initData, 'interactiveNavData', val);
            },
            get() {
                const navData = this.initData.interactiveNavData;
                const rs = {
                    ...DEFAULT_NAV_SETTIGN,
                    ...navData,
                };

                return rs;
            },
        },
        toolBtnsForPC() {
            const toolBtns = [
                {
                    name: '发送表情',
                    icon: 'basic_emoji_line',
                    remote: true,
                },
                {
                    name: '音频通话',
                    icon: 'basic_call_line',
                    remote: true,
                },
                {
                    name: '视频通话',
                    icon: 'basic_video_line',
                    remote: true,
                },
                {
                    name: '商品',
                    icon: 'basic_bag_line',
                    remote: true,
                },
                {
                    name: '订单',
                    icon: 'basic_papers_line',
                    remote: true,
                },
                {
                    name: '截图',
                    icon: 'screenshot',
                    remote: false,
                },
            ];
            if(this.initData.isAllowSendFile) {
                toolBtns.splice(1, 0, {
                    name: '发送文件',
                    icon: 'basic_file_line',
                    remote: true,
                });
            }
            if(this.initData.isAllowSendImage) {
                toolBtns.splice(1, 0, {
                    name: '发送图片',
                    icon: 'basic_picture_line',
                    remote: true,
                });
            }
            if(this.initData.isSurvey) {
                toolBtns.push({
                    name: '服务评价',
                    icon: 'basic_satisfaction_line',
                    remote: true,
                });
            }
            if(this.initData.isManualClose) {
                toolBtns.push({
                    name: '结束会话',
                    icon: 'close_session_line',
                    remote: false,
                });
            }
            return toolBtns;
        },
        toolBtnsForMobile() {
            const toolBtns = [
                {
                    name: '商品',
                    icon: 'basic_bag_fill',
                    remote: true,
                },
                {
                    name: '订单',
                    icon: 'basic_papers_fill',
                    remote: true,
                },
            ];
            if(this.channelType !== 1) {
                toolBtns.unshift({
                    name: '音频通话',
                    icon: 'basic_call_fill',
                    remote: true,
                },
                {
                    name: '视频通话',
                    icon: 'basic_video_fill',
                    remote: true,
                });
            }
            if(this.initData.isAllowSendFile) {
                if(this.channelType === 1) {
                    toolBtns.unshift({
                        name: '发送视频',
                        icon: 'send_video_file',
                        remote: false,
                    });
                } else {
                    toolBtns.unshift({
                        name: this.channelType === 1 ? '发送视频' : '发送文件',
                        icon: 'basic_file_fill',
                        remote: true,
                    });
                }
            }
            if(this.initData.isAllowSendImage) {
                toolBtns.unshift({
                    name: '发送图片',
                    icon: 'basic_picture_fill',
                    remote: true,
                });
            }
            if(this.initData.isSurvey) {
                toolBtns.push({
                    name: '服务评价',
                    icon: 'basic_satisfaction_fill',
                    remote: true,
                });
            }
            if(this.initData.isManualClose) {
                toolBtns.push({
                    name: '结束会话',
                    icon: 'close_session_fill',
                    remote: false,
                });
            }
            return toolBtns;
        },
    },

    watch: {
        authorizeTip: {
            handler(newValue) {
                const { title, explain } = newValue;
                if (!title || title.length > this.authorizeTipEditFormRules.title[0].maxLength) {
                    this.authorizeFormError = true;
                    return;
                }
                if (explain.length > this.authorizeTipEditFormRules.explain[0].maxLength) {
                    this.authorizeFormError = true;
                    return;
                }
                this.authorizeFormError = false;
            },
            deep: true,
        },
        connectData(nextValue) {
            this.initData = nextValue;
        },
        initData: {
            handler(newData) {
                this.$emit('getNowData', newData, 'guidanceInfoForHudong');
            },
            deep: true,
        },
    },
    methods: {
        closeTip() {
            localStorage.setItem(CHATWINDOWSYSTEMEVENTTIPKEY, 1);
        },
        onContentAuthorizeTipEdit() {
            const { authorizeTip = {} } = this.initData;
            if (authorizeTip && authorizeTip.title) {
                this.authorizeTip = { ...authorizeTip };
            } else {
                this.authorizeTip = { ...authorizeTipDefault };
            }
            this.showContentAuthorizeTipEdit = true;
        },
        hiddenContentAuthorizeTipEdit() {
            this.showContentAuthorizeTipEdit = false;
        },
        authorizeTipSubmit(e) {
            e.preventDefault();
            this.hiddenContentAuthorizeTipEdit();
            this.initData.authorizeTip = { ...this.authorizeTip };
        },
        saveData() {
            this.$emit('getConnectInfoData', this.initData);
        },
    },
};
</script>

<style lang="less">
@import 'style.less';
</style>
